import { Component, OnInit } from '@angular/core';
import { faPalette } from '@fortawesome/pro-regular-svg-icons';
import { Subject, catchError, map, takeUntil, throwError } from 'rxjs';
import { AppConfig } from '@tech-utils/app-config.service';

import { HttpClient } from '@angular/common/http';
import { TechDialogsService } from '../tech-dialogs.service';

@Component({
  selector: 'tech-theme-selector',
  templateUrl: './theme-selector.component.html',
  styleUrls: ['./theme-selector.component.scss'],
  host: { ['style']: 'height: 100%' },
})
export class ThemeSelectorComponent implements OnInit {
  //Themes
  themes: string[] = undefined;
  private selectedTheme: string;
  private unsubscribe$ = new Subject<void>();

  public get SelectedTheme() {
    return this.selectedTheme;
  }
  public set SelectedTheme(value: string) {
    this.setTheme(value);
  }

  faPalette = faPalette;

  private showThemeToggle = false;
  public get ShowThemeToggle() {
    return this.showThemeToggle;
  }

  constructor(
    private appCfg: AppConfig,
    private dialogService: TechDialogsService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.getThemes()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.themes = data;
      });
    this.showThemeToggle = localStorage.getItem('showThemeToggle') === 'true';
    /*
    this.showThemeToggle = ConfigService.settings.showThemeToggle;*/
    this.loadTheme();
  }

  loadTheme() {
    if (this.themes != undefined && this.themes.length > 0) {
      var theme = this.themes[0];
      var currentTheme = localStorage.getItem('theme');
      if (currentTheme) {
        this.setTheme(currentTheme);
      } else {
        currentTheme = theme.includes('.scss')
          ? theme.replace('.scss', '')
          : theme;
        //set theme
        //this.setTheme(currentTheme);
      }
    }
  }

  setTheme(theme) {
    if (theme != undefined) {
      this.load(theme);
      this.loadHeadImgs(theme);
    }
  }

  private loadHeadImgs(item) {
    let link = document.createElement('link');
    let link2 = document.createElement('link');
    let link3 = document.createElement('link');
    let link4 = document.createElement('link');
    let link5 = document.createElement('link');
    let link6 = document.createElement('link');
    let link7 = document.createElement('link');
    let link8 = document.createElement('link');
    link.setAttribute('href', './assets/img/' + item + '/LogoW/Logo_W_ico.png');
    link.setAttribute('rel', 'icon');
    link.setAttribute('type', 'image/x-icon');
    document.head.appendChild(link);
    link2.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_120x120.png'
    );
    link2.setAttribute('rel', 'apple-touch-icon');
    document.head.appendChild(link2);
    link3.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_152x152.png'
    );
    link3.setAttribute('rel', 'apple-touch-icon');
    link3.setAttribute('sizes', '152x152');
    document.head.appendChild(link3);
    link4.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_167x167.png'
    );
    link4.setAttribute('rel', 'apple-touch-icon');
    link4.setAttribute('sizes', '167x167');
    document.head.appendChild(link4);
    link5.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_180x180.png'
    );
    link5.setAttribute('rel', 'apple-touch-icon');
    link5.setAttribute('sizes', '180x180');
    document.head.appendChild(link5);
    link6.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_192x192.png'
    );
    link6.setAttribute('rel', 'icon');
    link6.setAttribute('sizes', '192x192');
    document.head.appendChild(link6);
    link7.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_128x128.png'
    );
    link7.setAttribute('rel', 'icon');
    link7.setAttribute('sizes', '128x128');
    document.head.appendChild(link7);
    link8.setAttribute(
      'href',
      './assets/img/' +
        localStorage.getItem('ThemeImg') +
        '/LogoW/Logo_W_180x180.png'
    );
    link8.setAttribute('rel', 'apple-touch-startup-image');
    document.head.appendChild(link8);
  }

  private load(item) {
    let theme = 'theme_' + item;
    //let theme = 'theme_TR';
    document.querySelector('html').classList.add(theme);
    this.appCfg.loadtheme(item + '.json').then(() => {
      this.changeCssColorVar();
      localStorage.setItem('theme', item);
    });
  }

  private changeCssColorVar() {
    //Principal Colors
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-01',
        AppConfig.cssVars.colors.principalColors[0]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-02',
        AppConfig.cssVars.colors.principalColors[1]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-03',
        AppConfig.cssVars.colors.principalColors[2]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-04',
        AppConfig.cssVars.colors.principalColors[3]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-05',
        AppConfig.cssVars.colors.principalColors[4]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-06',
        AppConfig.cssVars.colors.principalColors[5]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--color-07',
        AppConfig.cssVars.colors.principalColors[6]
      );

    //Color Graphic
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-00',
        AppConfig.cssVars.colors.colorGraphic[0]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-01',
        AppConfig.cssVars.colors.colorGraphic[1]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-02',
        AppConfig.cssVars.colors.colorGraphic[2]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-03',
        AppConfig.cssVars.colors.colorGraphic[3]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-04',
        AppConfig.cssVars.colors.colorGraphic[4]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-05',
        AppConfig.cssVars.colors.colorGraphic[5]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-06',
        AppConfig.cssVars.colors.colorGraphic[6]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-07',
        AppConfig.cssVars.colors.colorGraphic[7]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-08',
        AppConfig.cssVars.colors.colorGraphic[8]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-09',
        AppConfig.cssVars.colors.colorGraphic[9]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf-10',
        AppConfig.cssVars.colors.colorGraphic[10]
      );

    //Color Graphic2
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-00',
        AppConfig.cssVars.colors.colorGraphic2[0]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-01',
        AppConfig.cssVars.colors.colorGraphic2[1]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-02',
        AppConfig.cssVars.colors.colorGraphic2[2]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-03',
        AppConfig.cssVars.colors.colorGraphic2[3]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-04',
        AppConfig.cssVars.colors.colorGraphic2[4]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-05',
        AppConfig.cssVars.colors.colorGraphic2[5]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-06',
        AppConfig.cssVars.colors.colorGraphic2[6]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-07',
        AppConfig.cssVars.colors.colorGraphic2[7]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-08',
        AppConfig.cssVars.colors.colorGraphic2[8]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-09',
        AppConfig.cssVars.colors.colorGraphic2[9]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-10',
        AppConfig.cssVars.colors.colorGraphic2[10]
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--colorGraf2-11',
        AppConfig.cssVars.colors.colorGraphic2[11]
      );

    $('.theme_TR')
      .get(0)
      .style.setProperty('--white-color', AppConfig.cssVars.colors.whiteColor);
    $('.theme_TR')
      .get(0)
      .style.setProperty('--font-color', AppConfig.cssVars.colors.fontColor);
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--background-body-color',
        AppConfig.cssVars.colors.backgroundBodyColor
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--bto-background-color',
        AppConfig.cssVars.colors.btoBackgroundColor
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--background-headerPortfolio',
        AppConfig.cssVars.colors.backgroundHeaderPortfolio
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty('--font-base', AppConfig.cssVars.fontBase);
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--radius-box-portfolio',
        AppConfig.cssVars.radiusBoxPortfolio
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty('--radius-btn', AppConfig.cssVars.radiusBtn);
    $('.theme_TR')
      .get(0)
      .style.setProperty(
        '--radius-card-white',
        AppConfig.cssVars.radiusCardWhite
      );
    $('.theme_TR')
      .get(0)
      .style.setProperty('--radius-modal', AppConfig.cssVars.radiusModal);
    $('.theme_TR')
      .get(0)
      .style.setProperty('--radius-pictures', AppConfig.cssVars.radiusPictures);
  }

  public getThemes(): any {
    return this.http.get<any>('./assets/themes/comboThemes.json').pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.dialogService.openErrorDialog(err); //Token: Error en
        return throwError(err);
      })
    );
  }
}
